import {isEqual} from 'lodash';
import {Injectable} from '@angular/core';
import {UserAddress} from '../model/user-address.model';
import {UserAddressService} from '../service/user-address.service';
import {Keys, StorageService} from '../service/storage.service';
import {LoanApplication} from '../model/loan-application.model';
import {AddressProofType} from '../model/address-proof-type.model';

@Injectable()
export class UserAddressInteractor {
    private readonly userAddressService: UserAddressService;

    constructor(userAddressService: UserAddressService, private storageService: StorageService) {
        this.userAddressService = userAddressService;
    }

    public async create(userAddress: UserAddress, userId: string): Promise<string> {
        if (!userAddress._id) {
            return await this.userAddressService.create(userAddress, userId);
        } else {
            const existingUserAddress = await this.get(userAddress._id);
            if (!(isEqual(userAddress, existingUserAddress))) {
                await this.userAddressService.update(userAddress);
            }
            return existingUserAddress._id;
        }
    }

    public async get(addressId: string): Promise<UserAddress> {
        return await this.userAddressService.get(addressId);
    }

    async update(address: UserAddress): Promise<void> {
        await this.userAddressService.update(address);
    }

    public async addAddressProof(fileIds: string[], addressProofType: AddressProofType): Promise<void> {
        const loanApplication = this.storageService.getObject<LoanApplication>(Keys.LOAN_APPLICATION);
        const addressId = loanApplication.addressId;
        const userAddress = await this.userAddressService.get(addressId);
        if (userAddress.proofs[0].fileIds) {
            userAddress.proofs[0].fileIds.push(...fileIds);
        } else {
            userAddress.proofs[0].fileIds = fileIds;
        }
        await this.userAddressService.update(userAddress);
    }

    public async removeProofDocumentFile(fileId: string): Promise<void> {
        const loanApplication = this.storageService.getObject<LoanApplication>(Keys.LOAN_APPLICATION);
        const addressId = loanApplication.addressId;
        const userAddress = await this.userAddressService.get(addressId);
        userAddress.proofs[0].fileIds.splice(userAddress.proofs[0].fileIds.indexOf(fileId), 1);
        await this.userAddressService.update(userAddress);
    }
}
